import { class_type } from "../Docs/fable_modules/fable-library.3.7.1/Reflection.js";
import { Table_setOption } from "./Table.fs.js";

export class Table {
    constructor() {
    }
}

export function Table$reflection() {
    return class_type("Feliz.TanStack.Table.Pagination.Table", void 0, Table);
}

export function Table_setPagination(updater, table) {
    table._obj.setPagination(updater);
    return table;
}

export function Table_resetPagination(defaultState, table) {
    table._obj.resetPagination(defaultState);
    return table;
}

export function Table_hasPreviousPage_Z4395D14A(table) {
    return table._obj.getCanPreviousPage();
}

export function Table_hasNextPage_Z4395D14A(table) {
    return table._obj.getCanNextPage();
}

export function Table_setPageIndex(index, table) {
    table._obj.setPageIndex(index);
    return table;
}

export function Table_resetPageIndex(defaultState, table) {
    table._obj.resetPageIndex(defaultState);
    return table;
}

export function Table_setPageSize(size, table) {
    table._obj.setPageSize(size);
    return table;
}

export function Table_resetPageSize(defaultState, table) {
    table._obj.resetPageSize(defaultState);
    return table;
}

export function Table_getPageCount_Z4395D14A(table) {
    return table._obj.getPageCount();
}

export function Table_setPageCount(count, table) {
    Table_setOption({
        pageCount: count,
    }, table);
    return table;
}

export function Table_getPageOptions_Z4395D14A(table) {
    return table._obj.getPageOptions();
}

export function Table_getCanPreviousPage_Z4395D14A(table) {
    return table._obj.getCanPreviousPage();
}

export function Table_nextPage_Z4395D14A(table) {
    table._obj.nextPage();
    return table;
}

export function Table_previousPage_Z4395D14A(table) {
    table._obj.previousPage();
    return table;
}

export function Table_getPrePaginatedRowModel_Z4395D14A(table) {
    return table._obj.getPrePaginatedRowModel();
}

export function Table_getPaginationRowModel_Z4395D14A(table) {
    return table._obj.getPaginationRowModel();
}

//# sourceMappingURL=Pagination.fs.js.map
